module.exports = __webpack_public_path__ + "img/fluids.bd3669eb.svg";